(function () {
  lgkorUI.showAppBottomMenuOver(true); //앱 덮는식으로 변경
  function init() {
    var viewLength = 6;
    var template =
      "<li>" +
      '<div class="prod_box">' +
      '   <a href="#n" data-url="{{modelUrlPath}}">' +
      '       <div class="product_img">' +
      '           <img src="{{smallImageAddr}}" alt="">' +
      "       </div>" +
      '       <div class="product_info">' +
      '           <span class="main-title">' +
      '               <span class="main">{{#raw modelDisplayNamePlusSpec}}</span>' +
      '           </span>' +
      '           <div class="info_model">{{modelName}}</div>' +
      "       </div>" +
      "   </a>" +
      '   <div class="info_link">' +
      '       <a href="#n" data-url="{{infoLink}}">매장 상담 예약</a>' +
      // https://www.lge.co.kr/support/visit-store-reservation?orgCode=2206&cartPrdList=MD08751416 - 세일상품인 경우
      // https://www.lge.co.kr/support/visit-store-reservation?cartPrdList=MD08751416 - 세일 상품이 아닌 경우
      "   </div>" +
      "</div>" +
      "</li>";

    var shopId = $(".cont-wrap.subpage").data("shopId");
    var product = {
      saleInit: function (ajaxUrl, param) {
        var product = this;
        var infohead = $(".officehome_infohead.sale");
        var data = param || {};
        infohead.each(function () {
          var $this = $(this);
          var boxlist = $this.next(".officehome_boxlist");
          var wrap = boxlist.children("ul");
          var countArea = boxlist.children(".prod_count"); // 20220609 LGECOMVIO-41 총 개수 영역 할당
          var moreArea = boxlist.find(".officehome_more");
          var moreBtn = moreArea.children(".more_btn");

          lgkorUI.requestAjaxDataPost(ajaxUrl, data, function (result) {
            var list = result.sale;
            var html = "";

            wrap.empty();

            // start 20220609 LGECOMVIO-41 총 개수 표기 추가
            if (list.length > 0) {
              countArea.text("총 " + list.length + "개");
            } else {
              countArea.text("총 0개");
            }
            // end 20220609 LGECOMVIO-41 총 개수 표기 추가

            // start 20220701 할인 제품 없을 시 삭제
            if (list.length === 0 || list.length === undefined) {
              boxlist.find(".nolist").show();
              moreArea.hide();
              $(".cont-wrap.subpage").addClass("no_sale");
              return false;
            } else {
              boxlist.find(".nolist").hide();
            }
            // end 20220701 할인 제품 없을 시 삭제

            for (var i = 0; i < viewLength; i++) {
              if (list[i] !== undefined) {
                // list[i].infoLink = "https://www.lge.co.kr/support/visit-store-reservation?cartPrdList="+list[i].modelId;
                // if(list[i].storeCode !== undefined) {
                //     list[i].infoLink += "&orgCode="+list[i].storeCode;
                // }
                html += vcui.template(template, list[i]);
              }
            }

            wrap.append(html);
            if (viewLength >= list.length) {
              moreArea.hide();
            } else {
              moreArea.show();
            }
          });
          moreBtn.off("click").on("click", function () {
            product.more(wrap, ajaxUrl, param);
          });
        });
      },
      dispInit: function (ajaxUrl, param) {
        var product = this;
        var infohead = $(".officehome_infohead.disp");
        var data = param || {};
        infohead.each(function () {
          var $this = $(this);
          var boxlist = $this.nextAll(".officehome_boxlist");
          var wrap = boxlist.children("ul");
          var countArea = boxlist.children(".prod_count"); // 20220609 LGECOMVIO-41 총 개수 영역 할당
          var moreArea = boxlist.find(".officehome_more");
          var moreBtn = moreArea.children(".more_btn");
          var cate = $this.nextAll(".officehome_cata");
          var tabUi = cate.children(".ui_tab");

          lgkorUI.requestAjaxDataPost(ajaxUrl, data, function (result) {
            var list = result.disp;
            var html = "";
            wrap.empty();

            if (!$this.hasClass("firstInit")) {
              $this.closest("#product_disp").css("visibility", "hidden");
              $("#product_disp").show();

              // start 20220708 LGECOMVIO-41 파라미터에 따라 탭 활성화
              if (lgkorUI.getParameterByName("tabs2").length) {
                tabUi.vcTab(
                  "select",
                  Number(lgkorUI.getParameterByName("tabs2"))
                );
              }
              // end 20220708 LGECOMVIO-41 파라미터에 따라 탭 활성화

              var lion = tabUi.find("li.on");
              var pLeft = lion.position().left;
              var lionSize = lion.outerWidth();
              var scrollWrap = tabUi.children("ul");
              var scrollLeft = scrollWrap.scrollLeft();
              var scrollSize = scrollWrap[0].scrollWidth;
              var scrollWrapSize = scrollWrap.width();
              if (scrollWrap.outerWidth() / 2 < pLeft) {
                scrollWrap.scrollLeft(
                  pLeft - scrollWrapSize / 2 + scrollLeft + lionSize / 2
                );
              }

              if (!$(".cont-wrap.subpage").hasClass("no_sale")) {
                $(".officehome_productmenu").each(function () {
                  var $this = $(this);
                  $this.show();
                  $this.addClass("appear");
                  $this.find(".tabs-wrap").addClass("ui_tab").vcTab();
                });
              }
              // start 20220602 LGECOMVIO-41 파라미터에 따라 탭 활성화
              if (lgkorUI.getParameterByName("tabs").length) {
                $(".officehome_productmenu > .ui_tab").vcTab(
                  "select",
                  Number(lgkorUI.getParameterByName("tabs"))
                );
              }
              // end 20220602 LGECOMVIO-41 파라미터에 따라 탭 활성화
            }

            // start 20220609 LGECOMVIO-41 총 개수 표기 추가
            if (list.length > 0) {
              countArea.text("총 " + list.length + "개");
            } else {
              countArea.text("총 0개");
            }
            // end 20220609 LGECOMVIO-41 총 개수 표기 추가

            if (list.length === 0 || list.length === undefined) {
              var nolist = boxlist.find(".nolist");
              nolist.hide();
              moreArea.hide();
              if (data.search !== undefined) {
                nolist.eq(1).show();
                nolist
                  .eq(1)
                  .find(".nolist_txt")
                  .text("“" + data.search + "”에 대한검색 결과가 없습니다.");
              } else {
                nolist.eq(0).show();
              }
              $this.closest("#product_disp").css("visibility", "");
              $this.addClass("firstInit");
              return false;
            } else {
              boxlist.find(".nolist").hide();
            }

            // start 20220602 LGECOMVIO-41 상위 탭 클릭 시 파라미터 변경
            $(".officehome_productmenu > .ui_tab")
              .off("tabchange")
              .on("tabchange", function (e, data) {
                window.history.replaceState(
                  "",
                  "",
                  vcui.uri.updateQueryParam(
                    location.href,
                    "tabs",
                    data.selectedIndex
                  )
                );
              });
            // end 20220602 LGECOMVIO-41 상위 탭 클릭 시 파라미터 변경

            if (data.categoryId === undefined) {
              list.sort(function (a, b) {
                if (a.index < b.index) {
                  if (a.cate < b.cate) {
                    return 1;
                  } else {
                    return -1;
                  }
                }
                return 0;
              });
            }

            for (var i = 0; i < viewLength; i++) {
              if (list[i] !== undefined) {
                // list[i].infoLink = "https://www.lge.co.kr/support/visit-store-reservation?cartPrdList="+list[i].modelId;
                html += vcui.template(template, list[i]);
              }
            }
            wrap.append(html);
            if (viewLength >= list.length) {
              moreArea.hide();
            } else {
              moreArea.show();
            }

            if (!$this.hasClass("firstInit")) {
              setTimeout(function () {
                $this.closest("#product_disp").css("visibility", "");
                $this.addClass("firstInit");
              }, 200);
            }
          });

          moreBtn.off("click").on("click", function () {
            product.more(wrap, ajaxUrl, param);
          });
        });
      },
      more: function (wrap, ajaxUrl, param) {
        var data = param || {};
        lgkorUI.requestAjaxDataPost(ajaxUrl, data, function (result) {
          var list;
          if (wrap.closest("#product_sale").length > 0) {
            list = result.sale;
          } else {
            list = result.disp;
            if (data.categoryId === undefined) {
              list.sort(function (a, b) {
                if (a.index < b.index) {
                  if (a.cate < b.cate) {
                    return 1;
                  } else {
                    return -1;
                  }
                }
                return 0;
              });
            }
          }

          var html = "";
          var thisLength = wrap.children("li").length;
          var listCont = wrap.children("li").last(); // BTOCSITE-77417 [웹앱 접근성 개선활동] 전시_베스트샵 더보기 클릭 후 생성된 컨텐츠로 포커스 이동

          for (var i = thisLength; i < list.length; i++) {
            if (list[i] !== undefined && thisLength + viewLength > i) {
              html += vcui.template(template, list[i]);
            }
          }
          wrap.append(html);
          listCont.next('li').find('.prod_box > a').focus(); // BTOCSITE-77417 [웹앱 접근성 개선활동] 전시_베스트샵 더보기 클릭 후 생성된 컨텐츠로 포커스 이동
          var moreArea = wrap.siblings(".officehome_more");
          if (wrap.children("li").length === list.length) {
            moreArea.hide();
          }
        });
      },
    };
    window.mvJs = {
      saleInit: product.saleInit,
      dispInit: product.dispInit,
      more: product.more,
    };

    var tabWrap = $(document).find(".officehome_cata .ui_tab");
    var searchInp = $(document).find(".officehome_search input"); /* BTOCSITE-31320 [모니터링] 베스트샵 신규 오픈 매장 전시 제품 text box 내 [X]버튼 비노출 */
    var searchBtn = $(document).find(".officehome_search .btn-search");
    var deleteBtn = $(document).find(".officehome_search .btn-delete"); //BTOCSITE-56581 [모니터링 G] 베스트샵 신규오픈 매장 검색 창 취소 버튼 유지되는 현상
    var oldTabIndex = 0;

    /* BTOCSITE-31320 [모니터링] 베스트샵 신규 오픈 매장 전시 제품 text box 내 [X]버튼 비노출 */
    searchInp.addClass('ui_input_clearbutton')
    .attr('data-clear-button','button.btn-delete')
    .attr('data-autofocus','true')
    .attr('ui-modules','inputClearButton');
    /* //BTOCSITE-31320 [모니터링] 베스트샵 신규 오픈 매장 전시 제품 text box 내 [X]버튼 비노출 */

    //탭
    tabWrap.off("tabchange").on("tabchange", function (e, data) {
      if (oldTabIndex === data.selectedIndex) {
        return false;
      }
      oldTabIndex = data.selectedIndex;
      var $this = $(this);
      var lion = $this.find("li.on");
      deleteBtn.css("display", "none"); //BTOCSITE-56581 [모니터링 G] 베스트샵 신규오픈 매장 검색 창 취소 버튼 유지되는 현상
      var categoryId = $this.find("li.on > a").data("categoryid");
      mvJs.dispInit("/bestshop/findDispProducts.lgajax", {
        categoryId: categoryId,
        shopId: shopId,
        popupYn: "Y",
      });

      // var pLeft = lion.position().left;
      // var lionSize = lion.outerWidth();
      // var scrollWrap = $this.children("ul");
      // var scrollLeft = scrollWrap.scrollLeft();
      // var scrollSize = scrollWrap[0].scrollWidth;
      // var scrollWrapSize = scrollWrap.width();
      // scrollWrap.stop().animate(
      //   {
      //     scrollLeft: pLeft - scrollWrapSize / 2 + scrollLeft + lionSize / 2,
      //   },
      //   200
      // );

      // start 20220602 LGECOMVIO-41 탭 이동 시 검색 초기화
      searchBtn.prevAll("form").children("input").val("");
      // end 20220602 LGECOMVIO-41 탭 이동 시 검색 초기화
      // start 20220708 LGECOMVIO-41 하위 탭 클릭 시 파라미터 변경
      window.history.replaceState(
        "",
        "",
        vcui.uri.updateQueryParam(location.href, "tabs2", data.selectedIndex)
      );
      // end 20220708 LGECOMVIO-41 하위 탭 클릭 시 파라미터 변경
    });
    //검색
    searchBtn.off("click").on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      var input = $this.prevAll("form").children("input");
      var val = input.val() || undefined;
      var categoryId = $(".officehome_cata")
        .find("li.on > a")
        .data("categoryid");
      mvJs.dispInit("/bestshop/findDispProducts.lgajax", {
        categoryId: categoryId,
        shopId: shopId,
        search: val,
        popupYn: "Y",
      });
      // $this.focus();
      input.blur();
    });
    // start 20220602 LGECOMVIO-41 검색 엔터키 버그 수정
    searchBtn
      .prevAll("form")
      .children("input")
      .off("keydown")
      .on("keydown", function (e) {
        if (e.keyCode === 13) {
          e.preventDefault();
          searchBtn.trigger("click");
          // searchBtn.focus();
          $(this).blur();
        }
      });
    // end 20220602 LGECOMVIO-41 검색 엔터키 버그 수정

    mvJs.saleInit("/bestshop/findSalesProducts.lgajax", {
      shopId: shopId,
      popupYn: "Y",
    });
    setTimeout(function () {
      mvJs.dispInit("/bestshop/findDispProducts.lgajax", {
        categoryId: undefined,
        shopId: shopId,
        popupYn: "Y",
      });
    }, 300);
  }

  function checkStoremode() {
    var pathSplit = location.pathname.split("-");
    var strShopId = "";
    if(pathSplit.length > 1) {
      strShopId = pathSplit[1];
    }
    if(strShopId) {
      var ajaxUrl = "/bestshop/bestshopInfo.lgajax?shopId=" + strShopId;
      lgkorUI.requestAjaxDataPost(ajaxUrl, {}, function (result) {
        var data = result.shopInfo;
        if (data) {
          if (data.storeViewFlag != "Y") {
            var obj = {
              title: '.', ok: function () {
                window.location.href = "/bestshop/store-finder";
              }
            };
            var desc = '';
            obj = $.extend(obj, {title: '종료된 매장으로 매장정보를 찾을 수 없습니다.'});
            lgkorUI.alert(desc, obj);
          }
        }
      });
    }
  }

  $(document).ready(function () {
    // start 20220701 할인 제품 없을 시 삭제
    $(".officehome_productmenu .tabs-wrap.bar-type.ui_tab").each(function () {
      $(this).removeClass("ui_tab");
    });
    // end 20220701 할인 제품 없을 시 삭제
    init();
    vcui.require(["customer/bestShopModule/common"], function () {
      // setTimeout(function () {
      //   // start 20220602 LGECOMVIO-41 파라미터에 따라 탭 활성화
      //   if (lgkorUI.getParameterByName("tabs").length) {
      //     $(".officehome_productmenu > .ui_tab").vcTab(
      //       "select",
      //       Number(lgkorUI.getParameterByName("tabs"))
      //     );
      //   }
      //   // end 20220602 LGECOMVIO-41 파라미터에 따라 탭 활성화
      //   // start 20220708 LGECOMVIO-41 파라미터에 따라 탭 활성화
      //   if (lgkorUI.getParameterByName("tabs2").length) {
      //     $(".officehome_cata > .ui_tab").vcTab(
      //       "select",
      //       Number(lgkorUI.getParameterByName("tabs2"))
      //     );
      //   }
      //   // end 20220708 LGECOMVIO-41 파라미터에 따라 탭 활성화
      // }, 75);

      checkStoremode();
    });
  });

  // s:BTOCSITE-58582 [선감지] 베스트샵 매장전시제품 에서 텍스트 짤리는 현상
  function setNewBestRank(_prevCid){
    var prevCid = _prevCid; //히스토리 data-category-id
    var $best = $('.main-bestranking__tab .ui_stickyTab');
    var $bestLi = $('.main-bestranking__tab .ui_stickyTab li');
    var $bestSlider = $('.main-bestranking__content.ui_carousel_1_slider');
    var leftArr = [];
    var firstLeft = 0
    var isSelecting = false;
    for(var i=0; i< $bestLi.length; i++){
        if(i == 0){
            firstLeft = $bestLi.eq(i).offset().left;
        }
        leftArr[i] = $bestLi.eq(i).offset().left - firstLeft;
    }
    var idx = 0;
    if(prevCid){
        for(var i=0; i< $bestLi.length; i++){
            if($bestLi.eq(i).find('a').attr('data-category-id') === prevCid){
                idx = i;
            }
        }
    }
    
    $('.arrow-btn .prev').on('click',function(){
        var left  = Math.abs($best.vcSmoothScroll('getPosition').x);
        var idx = -1;
        for(var i=$bestLi.length-1; i >= 0; i--){
            if(leftArr[i] < left && idx == -1){
                idx = i;
            }
        }
        $best.vcSmoothScroll('prevPage');
    });
    $('.arrow-btn .next').on('click',function(){
        var left  = Math.abs($best.vcSmoothScroll('getPosition').x);
        var idx = -1;
        for(var i=0; i< $bestLi.length; i++){
            if(leftArr[i] > left && idx == -1){
                idx = i;
            }
        }
        $best.vcSmoothScroll('nextPage');
    });
    $best.on('smoothscrollend', function(e,data){
        activeBtn();
        if(data.isStart){
            $('.arrow-btn .prev').hide();
        }else if(data.isEnd){
            $('.arrow-btn .next').hide();
        }
    });
    $(window).on("resize", function () {
        activeBtn();
        if($best.vcSmoothScroll('getPosition').x == 0){
            $('.arrow-btn .prev').hide();
        }else if(Math.abs($best.vcSmoothScroll('getPosition').x) >= Math.abs($best.vcSmoothScroll('getMaxScrollX'))){
            $('.arrow-btn .next').hide();
        }
    }).on("resizeend.bestranking", function (e) {
        if(e.namespace != 'bestranking'){return;}
        $best.vcSmoothScroll("scrollToActive");
        //PC 터치 스와이프 방지
        if(window.innerWidth >= 768){  
            $('.main-bestranking__content').vcCarousel('instance').options.swipe = false;
        }else{
            $('.main-bestranking__content').vcCarousel('instance').options.swipe = true;
        }
        ////PC 터치 스와이프 방지
    })
    $best.on('stickyTabchange',function(e,_obj){
        select(_obj.selectedIndex);
    });
    $bestSlider.on('carouselafterchange', function (e, instance) {
        select(instance.currentSlide);
    });
    function init(){
        if(!$best.attr('ui-modules')){
            $best.vcStickyTab();
            //console.log('vcStickyTab 없음 모듈세팅시작');
        }
        if(!$bestSlider.attr('ui-modules')){
            $bestSlider.vcCarousel();
            //console.log('vcCarousel 없음 모듈세팅시작');
        }
        setTimeout(function(){
            $best.vcStickyTab('update'); 
            var bestCarousel = $('.main-bestranking__content').vcCarousel('instance');
            bestCarousel.setOption({initialSlide: idx})
            bestCarousel.reinit();
            bestCarousel.refresh();

            $(window).trigger('resize').trigger('resizeend.bestranking');
        });
    }
    function activeBtn(){
        if($best.width() < $best.find('.tabs').width()){
            $('.arrow-btn .next').show();
            $('.arrow-btn .prev').show();
        }else{
            $('.arrow-btn .next').hide();
            $('.arrow-btn .prev').hide();
        }
    }
    var preSelectIdx = -1;
    function select(_idx){
        if(isSelecting == true || preSelectIdx == _idx){return;}
        isSelecting = true;
        $best.vcStickyTab('select', _idx);
        $bestSlider.vcCarousel('instance').slideHandler(_idx, false, true);
        $(window).trigger('resize').trigger('resizeend.bestranking');
        preSelectIdx = _idx;
        // 베스트랭킹 GA 호출
        if ( bestRanking.variable.isVisible) {
            bestRanking.rankingSendDataLayer();
        }
        setTimeout(function(){isSelecting = false;},100);
    }
    init();
  }
  var bestRanking = {
    variable: {
        isVisible: false,
    },
    setting : function() {
        var self = this;
        self.$wrapper = $(".section--ranking");
        self.$tabsWrap = $(".tabs-wrap-new");
        self.categoryTempate = '{{#each (item, index) in itemList}}' +
                                '<li>' +
                                    '<a href="#" data-category-id="{{item.categoryId}}" data-category-name="{{item.categoryName}}">' +
                                        '<span class="thumb"><img src="/kr/images/BRK/img_BestRanking_{{item.categoryId}}_tab.png" alt="{{item.categoryName}}"></span>' +
                                        '<span class="sort">{{item.categoryName}}</span><em class="blind">선택됨</em>' +
                                    '</a>' +
                                '</li>' +
                                '{{/each}}';

        self.seasonThemeTempate =   '{{#each (item, index) in itemList}}' +
                                        '{{#if item.mainTitleUrl == "multiple-products" }}' +
                                            '<li class="line">' +
                                        '{{#else}}' +
                                            '<li>' +
                                        '{{/if}}' +
                                            '<a href="/best-ranking/{{item.mainTitleUrl}}" data-is-link="true">' +
                                                '<span class="gateway" style="background:{{item.backgroundRgb}}">{{item.addInfo1}}</span>' +
                                            '</a>' +
                                        '</li>' +
                                    '{{/each}}';
        self.productTempate = '{{#each (item, index) in itemList}}' +
                                '<div class="slide-conts ui_carousel_slide">' +
                                    '<ol class="main-bestranking__list">' +
                                    '{{#each (product, index) in item.productList}}' +
                                        '<li class="main-bestranking__item" data-ec-product="{{product.ecProductInfo}}" data-imp-event="microPlpOpen">' +
                                            '<a href="{{product.modelUrlPath}}" class="item__link" data-contents="{{product.gaDataContents}}">' +
                                                '<div class="item__badge">' +
                                                    '<div class="prod_badge">' +
                                                    '{{#if product.mltpPlcyBadgeFlag == "Y" }}' +
                                                        '<span class="badge_box multi-item">다품목할인</span>' +
                                                    '{{/if}}' +
                                                    '{{#if product.releaseBadgeFlag}}' +
                                                        '<span class="badge_box release-date">{{product.releaseBadgeFlag}}</span>' +
                                                    '{{/if}}' +
                                                    '</div>' +
                                                '</div>' +
                                                '<div class="item__image">' +
                                                    '<img src="{{product.mediumImageAddr}}" alt="{{product.modelDisplayName}}">' +
                                                    '{{#if product.lgecomOnlyFlag == "Y"}}' +
                                                        '<em class="badge lge-only"><span class="blind">닷컴 ONLY</span></em>' +
                                                    '{{/if}}' +
                                                '</div>' +
                                                '<div class="item__info">' +
                                                    '<div class="item__name">' +
                                                        '<span class="main-title">' +
                                                            '<span class="main">{{#raw product.modelDisplayNamePlusSpec}}</span>' +
                                                        '</span>' +
                                                    '</div>' +
                                                    '<span class="item__sku">{{product.modelName}}</span>' +
                                                    '<div class="item__price-wrap">' +
                                                        '<span class="item__price item__price--current">' +
                                                            '<strong class="item__number">{{vcui.number.addComma(product.maxBenefitPrice)}}</strong>원' +
                                                        '</span>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</a>' +
                                        '</li>' +
                                    '{{/each}}' +
                                    '</ol>' +
                                '</div>'+
                            '{{/each}}';
    },
    init : function() {
        var self = this;

        lgkorUI.requestAjaxDataPost("/mkt/api/bestRanking/retrieveHomeTodayRanking.lgajax", {}, function (result) {
                $(".section--ranking").eq(1).attr("style", "display:none !important");
                // BTOCSITE-51870 [전시] LG트윈스 우승기념 - 윈윈페스티벌 대응
                if (!vcui.isEmpty(result.data[0])) {
                    // 베스트랭킹 활성화
                    $("#bestRanking_section").show();
                    $("#bestRanking_section").css("visibility", "visible");

                    self.setting();

                    var categoryTemplate = vcui.template(self.categoryTempate, {itemList: result.data[0].homeBestRankingList});
                    self.$tabsWrap.find("ul").append(categoryTemplate);
                    var seasonThemeTemplate = vcui.template(self.seasonThemeTempate, {itemList: result.data[0].seasonThemeList});
                    self.$tabsWrap.find("ul").append(seasonThemeTemplate);
                    var productListTemplate = vcui.template(self.productTempate, {itemList: result.data[0].homeBestRankingList});
                    $(".main-bestranking__content").find(".slide-track").append(productListTemplate);
                    self.setRecentViewTab();

                    //BTOCSITE-44878
                    $('.item__badge').each(function(){
                        if($(this).height() == 0){
                            $(this).parent().addClass('no_badge');
                        }
                    });
                }
            });

        $('.section--ranking .section__link').on('click',function(e){
            var bestRankingIndex = $('.main-bestranking__tab .tabs li.on').index();
            sessionStorage.setItem('bestRankingTabIndex',bestRankingIndex);
        });

        $('.main-bestranking__tab .ui_stickyTab').on('stickyTabchange',function(e,_obj){
            // 베스트 랭킹 더보기버튼 url 파라미터 변경
            var categoryId = $('.main-bestranking__tab .tabs li.on').find("a").data("category-id") || "";
            var categoryName = $('.main-bestranking__tab .tabs li.on').find("a").data("category-name") || "";
            if (!vcui.isEmpty(categoryId) && !vcui.isEmpty(categoryName)) {
                $("#bestRanking_section .section__link").attr("href", "/best-ranking/todays?categoryId=" + categoryId + "&categoryName=" + categoryName);
                $("#bestRanking_section .section__link").attr("data-contents", categoryName);
            }
        });

    },
    setRecentViewTab : function() {
        var sessionItem = sessionStorage.getItem("recent_view_pdp_info");
        if (!vcui.isEmpty(sessionItem)) {
            var item = JSON.parse(sessionItem);
            if (vcui.isEmpty(item.categoryId)) {
                lgkorUI.requestAjaxDataPost("/mkt/api/bestRanking/retrieveCategoryId.lgajax", {modelId : item.modelId}, function (result) {
                    setNewBestRank(result.data[0].categoryId);
                });
            } else {
                setNewBestRank(item.categoryId);
            }
        } else {
            setNewBestRank();
        }
    },

    rankingBannerSendDataLayer : function() {

        var categoryName = "";
        categoryName = $("#bestRankingTab").find("li.on").find(".sort").text();

        if (typeof dataLayer !== 'undefined' && dataLayer) {
            dataLayer.push({
                'event': 'customEvent',
                'ga4event': 'banner_impression',
                'customEventCategory': '배너노출',
                'customEventAction': '배너노출 - 베스트랭킹',
                'customEventLabel': categoryName
            });
        }
    },

    rankingSendDataLayer : function() {
        $(".main-bestranking__item").removeAttr("data-imp-event");
        var idx = $('.main-bestranking__tab .tabs li.on').index();
        $(".main-bestranking__content .slide-conts").eq(idx).find("li").attr("data-imp-event", "microPlpOpen");

        if (typeof dataLayer !== 'undefined' && dataLayer) {
            dataLayer.push({
                'event': 'microPlpOpen'
            });
        }
    },

    checkViewBestRanking : function() {
        if ( !bestRanking.variable.isVisible && bestRanking.checkVisible() && $("#bestRankingTab").find("li.on").length > 0) {
            bestRanking.rankingBannerSendDataLayer();
            bestRanking.variable.isVisible = true;
        }

        bestRanking.variable.isVisible && window.removeEventListener('scroll', bestRanking.checkViewBestRanking);
    },

    checkVisible : function() {
        var viewportHeight = $(window).height(); // Viewport Height
        var scrolltop = $(window).scrollTop(); // Scroll Top
        var y = $(".section--ranking").eq(0).find(".section__inner").offset().top + $(".section--ranking").eq(0).find(".section__inner").height();

        // 화면에 안보여도 요소가 위에만 있으면 (페이지를 로드할때 스크롤이 밑으로 내려가 요소를 지나쳐 버릴경우)
        return ((y < (viewportHeight + scrolltop)));
    }

  };
  bestRanking.init();
  // e:BTOCSITE-58582 [선감지] 베스트샵 매장전시제품 에서 텍스트 짤리는 현상
})();
